import { render, staticRenderFns } from "./ItemProduct.vue?vue&type=template&id=b8c9ac20&scoped=true&"
import script from "./ItemProduct.vue?vue&type=script&lang=ts&"
export * from "./ItemProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ItemProduct.vue?vue&type=style&index=0&id=b8c9ac20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c9ac20",
  null
  
)

export default component.exports